import React, { useEffect, useState } from 'react';
import classes from "./HomePage2.module.css";
import { getGamesApi } from '../Http/http';
import { FaCopyright, FaStar } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import {
    Autoplay,
    EffectCoverflow,
} from "swiper/modules";
import Loader from '../Components/Loader';

const HomePage2 = () => {
    const [loading, setLoading] = useState(true);
    const [games, setGames] = useState(null);
    const [gamesCategoryWise, setGamesCategoryWise] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState("All");

    const fetchGames = async () => {
        try {
            setLoading(true);
            const response = await getGamesApi();
            setGames(response?.data?.result);

            // Filter out invalid entries
            const validGames = response?.data?.result.filter(
                (game) => game?.name && game?.category
            );

            // Group by category
            const categoryMap = {};
            validGames.forEach((game) => {
                if (!categoryMap[game.category]) {
                    categoryMap[game.category] = [];
                }
                categoryMap[game.category].push(game);
            });

            // Convert to array format
            const grouped = Object.keys(categoryMap).map((cat) => ({
                category: cat,
                data: categoryMap[cat],
            }));

            setGamesCategoryWise(grouped);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error, "error-------");
            alert("Something Went Wrong!");
        }
    }

    useEffect(() => {
        fetchGames();
    }, []);

    const handleNavigate = (path) => {
        window.location.href = path;
    }

    return (
        <main className={classes.main}>


            <div className={classes.section_hero}>
            {/* <header className={classes.header}> */}
                {/* <nav className={classes.nav}> */}
                    <div className={classes.logo_container}>
                        <img src="/assets/logo.jpg" alt="door2games" className={classes.logo} />
                    </div>
                {/* </nav> */}
            {/* </header> */}
                <div className={classes.circle_image_container}>
                    <img src="/assets/images/slider_circle.png" alt="circle" className={classes.circle_image} />
                </div>

                <div className={classes.circle_image_container2}>
                    <img src="/assets/images/slider_circle.png" alt="circle" className={classes.circle_image2} />
                </div>

                <div className={classes.hero_section_image_container}>
                    <img src="/assets/images/slider_img02.png" alt="girl holding gun" className={classes.hero_section_image} />
                </div>

                <div className={classes.slider_content}>
                    <h6 className="wow fadeInDown" data-wow-delay=".2s">Welcome to the Arena</h6>
                    <h2 className="tlt fix" data-in-effect="fadeInLeft">Door <span>2</span> Games</h2>
                    <p className="wow fadeInUp" data-wow-delay="2s">
                        Dive into 50+ thrilling games across action, puzzle, sports, and more. There's something for every player!
                    </p>
                    <button type="button" className={`${classes.explore_btn} wow fadeInUp`} data-wow-delay="2.2s"
                        onClick={() => {
                            const el = document.getElementById("games");
                            if (el) {
                                el.scrollIntoView({ behavior: "smooth" });
                            }
                        }}
                    >Start Playing</button>
                </div>

            </div>



            {loading ? <Loader /> : (
                <>
                    <div className={classes.section_carousel_container}>
                        <div className={classes.section_carousel_marquee}>
                            <div className={classes.section_carousel_sub_container}>
                                {data.map((item, index) => {
                                    return (
                                        <div key={index} className={classes.section_carousel_item}>
                                            <img src={item?.image_link} alt="" className={classes.section_carousel_item_image} />
                                        </div>
                                    )
                                })}

                                {data.map((item, index) => {
                                    return (
                                        <div key={index} className={classes.section_carousel_item}>
                                            <img src={item?.image_link} alt="" className={classes.section_carousel_item_image} />
                                        </div>
                                    )
                                })}

                                {data.map((item, index) => {
                                    return (
                                        <div key={index} className={classes.section_carousel_item}>
                                            <img src={item?.image_link} alt="" className={classes.section_carousel_item_image} />
                                        </div>
                                    )
                                })}


                            </div>
                        </div>

                        <h1 className={classes.section_grid_title} id="games">Focus and Play Top Games</h1>

                        <div className={classes.section_games_grid} >
                            <div className={classes.section_game_card}
                                onClick={() => {
                                    handleNavigate(games?.[0]?.game_url)
                                }}
                            >
                                <div className={classes.section_game_card_image_container}>
                                    <img src={games?.[0]?.img_url} alt={games?.[0]?.name} className={classes.section_game_card_image} />
                                </div>
                                <div className={classes.section_game_card_info}>
                                    <p className={classes.section_game_card_title}>
                                        {games?.[0]?.name}
                                    </p>

                                    <div className={classes.section_game_card_info_stars}>
                                        <FaStar className={classes.star_icon} />
                                        <FaStar className={classes.star_icon} />
                                        <FaStar className={classes.star_icon} />
                                        <FaStar className={classes.star_icon} />
                                        <FaStar className={classes.star_icon} />
                                    </div>

                                    <button type="button" className={classes.section_grid_card_play_button}>
                                        Play
                                    </button>

                                </div>
                            </div>

                            <div className={classes.section_game_card}
                                onClick={() => {
                                    handleNavigate(games?.[1]?.game_url)
                                }}
                            >
                                <div className={classes.section_game_card_image_container}>
                                    <img src={games?.[1]?.img_url} alt={games?.[1]?.name} className={classes.section_game_card_image} />
                                </div>
                                <div className={classes.section_game_card_info}>
                                    <p className={classes.section_game_card_title}>
                                        {games?.[1]?.name}
                                    </p>
                                    <div className={classes.section_game_card_info_stars}>
                                        <FaStar className={classes.star_icon} />
                                        <FaStar className={classes.star_icon} />
                                        <FaStar className={classes.star_icon} />
                                        <FaStar className={classes.star_icon} />
                                        <FaStar className={classes.star_icon} />
                                    </div>

                                    <button type="button" className={classes.section_grid_card_play_button}>
                                        Play
                                    </button>

                                </div>
                            </div>

                            <div className={classes.section_game_card}
                                onClick={() => {
                                    handleNavigate(games?.[2]?.game_url)
                                }}
                            >
                                <div className={classes.section_game_card_image_container}>
                                    <img src={games?.[2]?.img_url} alt={games?.[2]?.name} className={classes.section_game_card_image} />
                                </div>
                                <div className={classes.section_game_card_info}>
                                    <p className={classes.section_game_card_title}>
                                        {games?.[2]?.name}
                                    </p>
                                    <div className={classes.section_game_card_info_stars}>
                                        <FaStar className={classes.star_icon} />
                                        <FaStar className={classes.star_icon} />
                                        <FaStar className={classes.star_icon} />
                                        <FaStar className={classes.star_icon} />
                                        <FaStar className={classes.star_icon} />
                                    </div>

                                    <button type="button" className={classes.section_grid_card_play_button}>
                                        Play
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className={classes.section_carousel_games}>
                            <Swiper
                                modules={[
                                    Autoplay,
                                    EffectCoverflow,
                                ]}
                                loop
                                // effect={"coverflow"}
                                coverflowEffect={{
                                    slideShadows: false,
                                    rotate: 40
                                }
                                }
                                spaceBetween={14}
                                slidesPerView={5}
                                // navigation
                                autoplay={{
                                    delay: 500,
                                    disableOnInteraction: false,
                                }}
                                // pagination={{ clickable: true }}
                                // scrollbar={{ draggable: true }}
                                onSwiper={(swiper) => null}
                                breakpoints={{
                                    220: {
                                        slidesPerView: 1,
                                        spaceBetween: 0,
                                    },
                                    640: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                    768: {
                                        slidesPerView: 4,
                                        spaceBetween: 14,
                                    },
                                    1024: {
                                        slidesPerView: 5,
                                        spaceBetween: 20,
                                    },
                                }}
                                onSlideChange={() => null}
                            >
                                {games && games?.map((dataItem, i) => {
                                    return (
                                        <SwiperSlide key={i} >

                                            <div className={classes.section_game_card}
                                                onClick={() => {
                                                    handleNavigate(dataItem?.game_url)
                                                }}
                                            >
                                                <div className={classes.section_game_card_image_container}>
                                                    <img src={dataItem?.img_url} alt={dataItem?.name} className={classes.section_game_card_image} />
                                                </div>
                                                <div className={classes.section_game_card_info}>
                                                    <p className={classes.section_game_card_title}>
                                                        {dataItem?.name}
                                                    </p>

                                                    <div className={classes.section_game_card_info_stars}>
                                                        <FaStar className={classes.star_icon} />
                                                        <FaStar className={classes.star_icon} />
                                                        <FaStar className={classes.star_icon} />
                                                        <FaStar className={classes.star_icon} />
                                                        <FaStar className={classes.star_icon} />
                                                    </div>

                                                    <button type="button" className={classes.section_grid_card_play_button}>
                                                        Play
                                                    </button>

                                                </div>
                                            </div>

                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        </div>
                    </div>
                </>
            )}



            <div className={classes.section_categories}>
                <div className={classes.section_categories_header}>
                    <h1 className={classes.section_categories_heading}>
                        Game <span>Categories</span>
                    </h1>
                    <div className={classes.section_categories_menu}>
                        <div className={`${classes.categories_menu_item} ${selectedCategory == "All" && classes.active}`}
                            onClick={() => setSelectedCategory("All")}
                        >
                            All
                        </div>
                        {gamesCategoryWise?.map((dataItem, i) => {
                            return (
                                <div key={i} className={`${classes.categories_menu_item} ${selectedCategory == dataItem?.category && classes.active}`}
                                    onClick={() => setSelectedCategory(dataItem?.category)}
                                >
                                    {dataItem?.category}
                                </div>
                            )
                        })}
                        <div>

                        </div>
                    </div>
                </div>

                <div className={classes.section_games_grid}>
                    {selectedCategory === "All" ?
                        games?.map((dataItem, index) => {
                            return (
                                <div className={classes.section_game_card} key={index}
                                    onClick={() => {
                                        handleNavigate(dataItem?.game_url)
                                    }}
                                >
                                    <div className={classes.section_game_card_image_container}>
                                        <img src={dataItem?.img_url} alt={dataItem?.name} className={classes.section_game_card_image} />
                                    </div>
                                    <div className={classes.section_game_card_info}>
                                        <p className={classes.section_game_card_title}>
                                            {dataItem?.name}
                                        </p>

                                        <div className={classes.section_game_card_info_stars}>
                                            <FaStar className={classes.star_icon} />
                                            <FaStar className={classes.star_icon} />
                                            <FaStar className={classes.star_icon} />
                                            <FaStar className={classes.star_icon} />
                                            <FaStar className={classes.star_icon} />
                                        </div>

                                        <button type="button" className={classes.section_grid_card_play_button}>
                                            Play
                                        </button>

                                    </div>
                                </div>
                            )
                        })

                        : gamesCategoryWise?.filter((item) => item?.category == selectedCategory)?.[0]?.data.map((dataItem, index) => {
                            return (
                                <div className={classes.section_game_card} key={index}
                                    onClick={() => {
                                        handleNavigate(dataItem?.game_url)
                                    }}
                                >
                                    <div className={classes.section_game_card_image_container}>
                                        <img src={dataItem?.img_url} alt={dataItem?.name} className={classes.section_game_card_image} />
                                    </div>
                                    <div className={classes.section_game_card_info}>
                                        <p className={classes.section_game_card_title}>
                                            {dataItem?.name}
                                        </p>

                                        <div className={classes.section_game_card_info_stars}>
                                            <FaStar className={classes.star_icon} />
                                            <FaStar className={classes.star_icon} />
                                            <FaStar className={classes.star_icon} />
                                            <FaStar className={classes.star_icon} />
                                            <FaStar className={classes.star_icon} />
                                        </div>

                                        <button type="button" className={classes.section_grid_card_play_button}>
                                            Play
                                        </button>

                                    </div>
                                </div>
                            )
                        })
                    }

                </div>

            </div>

            <footer className={classes.section_footer}>
                <div className={classes.section_footer_sub_container}>
                    <FaCopyright className={classes.copyright_icon} />
                    <p className={classes.section_footer_text}>Rainboo Softmate {new Date().getFullYear()} </p>
                </div>
            </footer>
        </main>
    )
}

export default HomePage2;

const data = [
    {
        image_link: "/assets/brand_logo01.png"
    },
    {
        image_link: "/assets/brand_logo02.png"
    },
    {
        image_link: "/assets/brand_logo03.png"
    }
    , {
        image_link: "/assets/brand_logo04.png"
    }
    , {
        image_link: "/assets/brand_logo05.png"
    },
    {
        image_link: "/assets/brand_logo06.png"
    }
]